import AbstractContextObject from "../../../../../shared/src/ranj/app/core/AbstractContextObject";
import SaveEvent from "../../../../../shared/src/ranj/equalture/savegame/SaveEvent";
import GameConfig from "../model/GameConfig";
import GameModel from "../model/GameModel";
import GameStatus from "../model/GameStatus";

export default class SaveController extends AbstractContextObject {

    /**
     * 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {GameModel} gameModel 
     * @param {GameConfig} gameConfig 
     */
    constructor(dispatcher, gameModel, gameConfig) {
        super(dispatcher);
        this._gameModel = gameModel;
        this._gameConfig = gameConfig;

        this._handleGameModelEvent = this._handleGameModelEvent.bind(this);
        this._gameModel.addEventListener(GameModel.ELAPSED_TIME, this._handleGameModelTime.bind(this));
        this._gameModel.addEventListener(GameModel.PUZZLE, this._handleGameModelEvent);
        this._gameModel.addEventListener(GameModel.SUBMIT, this._handleGameModelEvent);
        this._gameModel.addEventListener(GameModel.STATUS, this._handleGameModelStatus.bind(this));
        this._gameModel.addEventListener(GameModel.MATCH, this._handleGameModelEvent);
        this._gameModel.addEventListener(GameModel.MISMATCH, this._handleGameModelEvent);

        this._lastSave = 0;
        this._lastTimeBasedSave = 0;
    }

    _handleGameModelTime(e) {
        if (Date.now() - Math.max(this._lastTimeBasedSave, this._lastSave) > this._gameConfig.getValue("savegame.interval")) {
            this._lastTimeBasedSave = Date.now();
            this._scheduleSave();
        }
    }

    _handleGameModelStatus() {
        if (this._gameModel.puzzleIndex > -1) {
            if (this._delayedSave) {
                this.killDelayedCall(this._delayedSave);
            }
            this._save();
        }
    }

    _handleGameModelEvent() {
        if (this._gameModel.puzzleIndex > -1) {
            this._scheduleSave();
        }
    }

    _scheduleSave() {
        if (this._delayedSave) {
            this.killDelayedCall(this._delayedSave);
        }
        this._delayedSave = this.callDelayed(this._save.bind(this), 50);
    }

    _save() {
        this._lastSave = Date.now();
        this.dispatch(SaveEvent.SAVE);
    }

}
